import SvgWrapper from './SvgWrapper';
import { AllergnIconProps } from './types';

const FishIcon = ({
  innerColor = '#000',
  outerColor = '#fff',
  ...props
}: AllergnIconProps) => {
  return (
    <SvgWrapper {...props}>
      <g
        id="Grupo_65"
        data-name="Grupo 65"
        transform="translate(-297 -1738.545)"
      >
        <g
          id="Rectángulo_2"
          data-name="Rectángulo 2"
          transform="translate(297 1738.545)"
          fill="#fff"
          stroke={innerColor}
          strokeWidth={1}
        >
          <rect width="27" height="27" rx="2" stroke={innerColor} stroke-width="1"/>
          <rect x="0.5" y="0.5" width="26" height="26" rx="1.5" stroke-width="1" fill={outerColor} />
        </g>
        <g id="fish" transform="translate(300.697 1742.751)" fill={innerColor}>
          <path
            id="Trazado_9060"
            data-name="Trazado 9060"
            d="M420.195,72.484a.3.3,0,1,0,.424,0A.3.3,0,0,0,420.195,72.484Zm0,0"
            transform="translate(-403.266 -70.229)"
          />
          <path
            id="Trazado_9061"
            data-name="Trazado 9061"
            d="M16.68,0A12.534,12.534,0,0,0,9.507,2.9,4.381,4.381,0,0,0,5.622,3.979a1.05,1.05,0,0,0,0,1.54L6.866,6.7a18.061,18.061,0,0,0-.958,5.626,4.349,4.349,0,0,0-2.318-.658A4.3,4.3,0,0,0,.611,12.835a.35.35,0,0,0,0,.513,4.3,4.3,0,0,0,2.978,1.169,4.416,4.416,0,0,0,1.463-.247,3.81,3.81,0,0,0-.26,1.387,3.865,3.865,0,0,0,1.233,2.823.4.4,0,0,0,.542,0A3.865,3.865,0,0,0,7.8,15.658a3.818,3.818,0,0,0-.694-2.2,21.01,21.01,0,0,0,5.934-.908l1.244,1.179a1.2,1.2,0,0,0,1.624,0,3.87,3.87,0,0,0,1.135-3.683A11.28,11.28,0,0,0,20.1,3.211,3.367,3.367,0,0,0,19.364.7,3.861,3.861,0,0,0,16.68,0ZM6.163,4.492a3.565,3.565,0,0,1,2.631-.951A7.865,7.865,0,0,0,7.167,5.957l-1-.952a.35.35,0,0,1,0-.513Zm-4.706,8.6a3.54,3.54,0,0,1,2.132-.7,3.54,3.54,0,0,1,2.132.7,3.54,3.54,0,0,1-2.132.7,3.541,3.541,0,0,1-2.132-.7ZM6.3,17.68a3.136,3.136,0,0,1,0-4.043,3.136,3.136,0,0,1,0,4.043Zm9.071-4.461a.4.4,0,0,1-.541,0l-1-.952a8.4,8.4,0,0,0,2.548-1.542A3.185,3.185,0,0,1,15.368,13.218ZM19.336,3.186a9.118,9.118,0,0,1-.812,3.26,4.364,4.364,0,0,1-3.231-.55.4.4,0,0,0-.529.11.352.352,0,0,0,.116.5,5.215,5.215,0,0,0,3.25.741,11.529,11.529,0,0,1-1.791,2.46h0c-.139.146-.284.291-.431.43-2.117,2.007-6.234,2.608-9.236,2.6C6.66,9.891,7.29,5.99,9.412,3.979c.148-.141.3-.278.454-.408a12.2,12.2,0,0,1,2.6-1.7A4.466,4.466,0,0,0,12.8,4.131a.39.39,0,0,0,.5.2.357.357,0,0,0,.213-.472,3.7,3.7,0,0,1-.2-2.362,10.545,10.545,0,0,1,3.4-.769,3.206,3.206,0,0,1,2.114.487,2.78,2.78,0,0,1,.513,1.969Zm0,0"
            transform="translate(-0.499 0)"
          />
          <path
            id="Trazado_9062"
            data-name="Trazado 9062"
            d="M341.508,134.469a.3.3,0,1,0,.424,0A.3.3,0,0,0,341.508,134.469Zm0,0"
            transform="translate(-328.249 -129.468)"
          />
        </g>
      </g>
    </SvgWrapper>
  );
};

export default FishIcon;
